import axios from 'axios';
import API from "../config/API";

export const cashupService = {
    getCashupHistory,
    getCashupById,
    createCashup,
    updateCashup,
    completeCashup,
    getCashupStats
};

/**
 * Get cash up history with optional filters
 * @param {Object} params - Query parameters (date range, pagination, etc.)
 * @returns {Promise} - API response
 */
function getCashupHistory(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    // Use POST instead of GET for better compatibility
    return axios.post(API.CASHUP_HISTORY, params, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}

/**
 * Get cash up by ID
 * @param {String} cashupId - ID of the cash up to retrieve
 * @returns {Promise} - API response
 */
function getCashupById(cashupId) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    // Use the RESTful GET endpoint with the cashupId in the URL
    return axios.get(`${API.CASHUP_GET_BY_ID}/${cashupId}`, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}

/**
 * Create a new cash up
 * @param {Object} data - Cash up data
 * @returns {Promise} - API response
 */
function createCashup(data) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.post(API.CASHUP_CREATE, data, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}

/**
 * Update an existing cash up
 * @param {String} cashupId - ID of the cash up to update
 * @param {Object} data - Updated cash up data
 * @returns {Promise} - API response
 */
function updateCashup(cashupId, data) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.put(`${API.CASHUP_UPDATE}/${cashupId}`, data, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}

/**
 * Complete a cash up (also handles saving the data)
 * @param {String} cashupId - ID of the cash up to complete
 * @param {Object} data - Cash up data to save
 * @returns {Promise} - API response
 */
function completeCashup(cashupId, data) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    return axios.put(`${API.CASHUP_COMPLETE}/${cashupId}/complete`, data, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}

/**
 * Get cash up statistics
 * @param {Object} params - Query parameters (date range, etc.)
 * @returns {Promise} - API response
 */
function getCashupStats(params) {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    
    // Convert params to query string
    const queryString = params ?
        '?' + Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&') : '';
            
    return axios.get(API.CASHUP_STATS + queryString, { headers: headers })
        .then(response => {
            // Transform the response to match what the frontend expects
            if (response.data && response.data.statusCode === 1 && response.data.responseData) {
                // Restructure the response to match the expected format
                return {
                    data: {
                        status: response.data.responseData.status,
                        message: response.data.responseData.message,
                        data: response.data.responseData.data
                    }
                };
            }
            return response;
        });
}